import { render } from "./TabelDataBiayaPelunasan.vue?vue&type=template&id=6a4c7f46"
import script from "./TabelDataBiayaPelunasan.vue?vue&type=script&lang=js"
export * from "./TabelDataBiayaPelunasan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__